export default {
  /**
   * Navigations (main and submenus)
   */
  // Main navigation
  navigation: {
    routines: {
      title: 'Routines',
      menuTitle: 'Routines',
    },
  },
  // Participant submenu
  participantNavigation: {
    swap: {
      title: 'Participant',
      menuTitle: 'Swaps',
    },
    swaps: {
      title: 'Participant',
      menuTitle: 'Swaps',
    },
    routines: {
      title: 'Participant',
      menuTitle: 'Routines',
    },
    smartSurvey: {
      title: 'Participant',
      menuTitle: 'Smart Survey',
    },
  },
  /**
   * Participant
   */
  // Participant details page
  participantDetails: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Smart survey available',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal available',
  },
  // Participant smart survey page
  participantSmartSurvey: {
    pageTitle: {
      bold: 'Smart',
      normal: 'Survey',
    },
  },
  // Participant Routines
  participantRoutines: {
    browseAndApplyButton: 'Browse and apply routines',
    // Remove all activities dialog
    removeAllActivities: {
      title: 'Remove all activities from this day?',
    },
  },
  // Participant Routines Progress
  participantRoutinesProgress: {
    sectionExercisesActivities: {
      title: 'Exercises & Activities',
      AM_Activities: 'Activities AM',
      PM_Activities: 'Activities PM',
    },
    sectionDailyPerformance: {
      exercisesAndActivities: 'Exercises & Activities',
      AM_Activities: 'Activities AM',
      PM_Activities: 'Activities PM',
      activitySkipped: 'Activity skipped',
    },
  },
  // Participant Swaps
  participantSwaps: {
    notFound: 'There are no swaps',
  },
  // Participant Swap
  participantSwap: {
    notFound: 'Swap not found',
    goBackToSwaps: 'Go back to swaps',
    editSwap: 'Edit Swap',
    deleteSwap: 'Delete Swap',
  },
  // Participant Swap - Swap Dialog
  swapDialog: {
    swap: 'Swap',
  },
  // Participant Swap - Swap Entry Dialog
  swapEntryDialog: {
    swap: 'Swap',
  },
  // Add participant dialog
  addParticipantDialog: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Smart survey available',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal available',
  },
  /**
   * Routines (Exercises & Activities)
   */
  // Apply Routines from Participant Routines (RoutineParticipantApplyDialog)
  participantApplyRoutines: {
    title: 'Apply routine',
    submit: 'Apply routine',
  },
  // Sequence Participant Apply Dialog
  sequenceParticipantApplyRoutines: {
    title: 'Apply routine',
    submit: 'Apply routine',
  },
  // Apply routines form participant routines and apply sequence (action: applySequence)
  applySequence: {
    successMessage: 'Routine assigned!',
  },
  // Edit activity modal
  editActivityModal: {
    title: 'Edit activity',
    // Change participant exercise/activity (changeParticipantExercise)
    participantSuccessMessage: {
      activityLabel: 'Activity',
    },
  },
  // Sequence Exercise Dialog
  sequenceExerciseDialog: {
    activityLabel: 'activity',
  },
  exerciseDefinitionDialog: {
    ActivityLabel: 'Activity',
    activityLabel: 'activity',
    mobileMedia: 'Mobile media',
  },
  // Routines page (exercises.vue)
  routines: {
    tabActivities: 'Activities & Exercises',
    tabRoutines: 'Routines',
    createAMPMActivity: 'Create AM/PM Activity',
    // v-dialog delete exercise
    removeThisActivity: {
      title: 'Are you sure you want to remove this activity?',
    },
    // v-dialog delete exercise folder
    removeExerciseFolder: {
      content: 'Do you want to remove all Activities inside?',
      optionRemoveAll: 'Remove all Activities and Folder',
      optionRemoveFolderOnly: 'Remove Folder and keep Activities',
    },
  },
  /**
   * Company (practice)
   */
  // Company details page
  companyDetails: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Smart survey available',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal available',
  },
  addPracticeDialog: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Smart survey available',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal available',
  },
  addPracticePatientDialog: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Smart survey available',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal available',
  },
  newPracticeUserDialog: {
    surveyFlag: 'Survey available',
  },
  practiceUserDialog: {
    surveyFlag: 'Survey available',
  },
  /**
   * Advisor Dashboard (Participant Dashboard screen)
   */
  participantsDashboard: {
    routines: 'Routines',
    totalRoutines: 'Total Routines',
    totalSwaps: 'Total Swaps',
    swaps: 'Swaps',
    lastUpdatedSwap: 'Last updated swap',
    routinesSkipped: 'Routines Skipped',
  },
  /**
   * Media library
   */
  library: {
    createActivity: 'Create activity',
    successCreateActivity: 'Activity added!',
  },
}
